import {
  GET_ORDERS_SUPPLIER,
  GET_ORDER_BY_ID,
  GET_NEW_ORDERS,
  UPDATE_ORDER_STATUS,
  CREATE_NOTE,
  CANCEL_ORDER,
  PACKED_ORDER,
  SHIPPED_ORDER,
  ACTIVE_ORDERS,
  GET_NEW_ORDER_COUNT,
  UPDATE_ORDER_DETAILS
} from './ApiConstants';
import api from './ApiHandler';

export const getOrdersByPage = async (payload: any) => {
  return await api.get(GET_ORDERS_SUPPLIER, { params: payload });
};

export const getActiveOrders = async (payload: any) => {
  return await api.get(ACTIVE_ORDERS, { params: payload });
};

export const getOrderById = async (payload: any) => {
  return await api.get(GET_ORDER_BY_ID, { params: { ...payload } });
};

export const getNewOrderSummary = async (payload: any) => {
  return await api.get(GET_NEW_ORDERS, { params: payload });
};

export const updateOrderStatus = async (payload: any) => {
  return await api.post(UPDATE_ORDER_STATUS, { ...payload });
};

export const createSupplierNoteApi = async (payload: any) => {
  return await api.post(CREATE_NOTE, { ...payload });
};

export const cancelOrderStatus = async (payload: any) => {
  return await api.post(CANCEL_ORDER, { ...payload });
};

export const orderProceed = async (payload: any) => {
  return await api.post('/split-order', { ...payload });
};

export const packedOrderStatus = async (payload: any) => {
  return await api.post(PACKED_ORDER, { ...payload });
};

export const shippedOrderStatus = async (payload: any) => {
  return await api.post(SHIPPED_ORDER, { ...payload });
};

export const getNewOrderCount = async (payload: any) => {
  return await api.get(GET_NEW_ORDER_COUNT);
};

export const updateOrderDetails = async (payload: any) => {
  return await api.post(UPDATE_ORDER_DETAILS, { ...payload });
};